import { createSlice } from '@reduxjs/toolkit'

export interface IViewCreditBasedFeatureModal {
    message: string
    openModal: boolean
    showButtons: boolean
}

const initialState: IViewCreditBasedFeatureModal = {
    message: '',
    openModal: false,
    showButtons: false
}

const viewCreditBasedFeatureModalSlice = createSlice({
    name: 'subscription-payment/add-card-detail-modal',
    initialState,
    reducers: {
        setCreditBasedFeatureModal(state, action) {
            state.message = action.payload.message
            state.openModal = action.payload.openModal
            state.showButtons = action.payload.showButtons
        }
    }
})

export const viewCreditBasedFeatureModalActions = viewCreditBasedFeatureModalSlice.actions
export default viewCreditBasedFeatureModalSlice.reducer
